import { Component, OnInit, HostListener } from '@angular/core';
import { ContentService } from './shared/services/content.service';
import { SweetAlert } from "sweetalert/typings/core";
import { AuthGuardService } from './shared/services/auth-guard.service';


const swal: SweetAlert = require("sweetalert");
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit  {
  isLoading = false;
  @HostListener('window:unload', ['$event'])
  unloadHandler(event: any) {
    // Trigger logout logic when the window is unloaded (tab/window is closed)
    this.authService.logout();
  }
  constructor(public contentService:ContentService, private authService: AuthGuardService){}
  ngOnInit(): void {
    this.contentService.loaderSubscriber.subscribe(res=>{
      this.isLoading = res;
    })

    const dialog:any = document.getElementById('custom-dialog');
    console.log("Dialog ", dialog)

  }
  title = 'nrlm-aajeevika';
}

